import { BodyLG, BodyXL, Heading2XL, Heading4XL } from "../../../typography";

import { officeImages } from "../config/lifeAtVerseConfig";

export const OfficeGridSection = () => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-y-[4em]">
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-[1em]">
        <Heading4XL className="tw-my-0 tw-hidden tw-text-blue-dark-3 min440:tw-flex">
          We believe in the office
        </Heading4XL>
        <Heading2XL className="tw-my-0 tw-text-blue-dark-3 min440:tw-hidden">
          We believe in the office
        </Heading2XL>
        <BodyXL className="tw-my-0 tw-hidden tw-text-center tw-text-gray-2 min440:tw-flex">
          Most roles at Verse are based out of our New York City office. Working
          together in person is a core part of our culture.
        </BodyXL>
        <BodyLG className="tw-my-0 tw-text-center tw-text-gray-2 min440:tw-hidden">
          Most roles at Verse are based out of our New York City office. Working
          together in person is a core part of our culture.
        </BodyLG>
      </div>
      <div className="tw-hidden tw-h-[750px] tw-w-full tw-grid-cols-3 tw-grid-rows-3 tw-gap-[1em] min840:tw-grid">
        {officeImages.map((image, index) => (
          <img key={index} src={image.src} className={image.className} />
        ))}
      </div>
    </div>
  );
};
